/* eslint-disable */
import React from 'react'
import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'
import {
    Home,
    BookOpen,
    ClipboardCheck,
    Calendar,
    Bell,
    Shield,
    LogIn,
    TrendingUp,
    Building2,
} from 'lucide-react'
import axios from 'axios'
import { isAdmin as checkIsAdmin } from '../../utils/auth'
import './Sidebar.css'

function Sidebar({
    toggleNotificationDrawer,
    toggleProfilePopover,
    unreadCount = 0,
    isNotificationOpen,
    isProfileOpen,
}) {
    const userData = useSelector((state) => state.userData)
    const user = userData?.user
    const isLoggedIn = !!user && user.id !== undefined
    const name = user
        ? `${user.firstName || ''} ${user.lastName || ''}`.trim() ||
          user.name ||
          'User Profile'
        : 'User Profile'
    const isAdmin = isLoggedIn && checkIsAdmin(user)

    const [hasOrg, setHasOrg] = React.useState(false)
    const [courses, setCourses] = React.useState([])

    React.useEffect(() => {
        if (!isLoggedIn) {
            setHasOrg(false)
            setCourses([])
            return
        }

        const checkOrganizations = async () => {
            try {
                const res = await axios({
                    method: 'get',
                    url: `${process.env.REACT_APP_BASE_URL}/api/v2/courses`,
                    headers: { 'Content-Type': 'application/json' },
                })
                const list = res.data || []
                setCourses(list)
                const hasAnyOrg = list.some((course) => !!course.organizationId)
                setHasOrg(hasAnyOrg)
            } catch (error) {
                console.error('Error checking organizations in sidebar:', error)
            }
        }

        checkOrganizations()
    }, [isLoggedIn])

    const getInitials = (nameStr) => {
        if (!nameStr || nameStr === 'User Profile') return 'UP'
        const parts = nameStr.split(' ').filter(Boolean)
        if (parts.length === 0) return 'UP'
        if (parts.length === 1) return parts[0][0].toUpperCase()
        return (parts[0][0] + parts[1][0]).toUpperCase()
    }

    return (
        <aside id="sidebar">
            <div className="sidebar-logo-sec">
                <NavLink to="/" title="Home" className="logo-link">
                    <div className="logo-img-container">
                        <img
                            alt="myAcademic Logo"
                            onError={(e) => {
                                e.target.src =
                                    'https://placehold.co/80x80/0055a2/ffffff?text=mA'
                                e.target.onerror = null
                            }}
                            src="/logo-new.png"
                        />
                    </div>
                </NavLink>
                <div className="sidebar-divider" />
            </div>

            <nav className="sidebar-nav">
                <NavLink
                    exact
                    activeClassName="sidebar-item-active"
                    className="sidebar-item"
                    to="/"
                >
                    <Home />
                    <span>Home</span>
                </NavLink>

                {isLoggedIn &&
                    (hasOrg || isAdmin) &&
                    (() => {
                        const coursesWithOrg = courses.filter(
                            (course) => !!course.organizationId
                        )
                        const orgLink =
                            !isAdmin && coursesWithOrg.length === 1
                                ? `/course/${coursesWithOrg[0].id}`
                                : '/org'
                        return (
                            <NavLink
                                activeClassName="sidebar-item-active"
                                className="sidebar-item"
                                to={orgLink}
                            >
                                <Building2 />
                                <span>Organizations</span>
                            </NavLink>
                        )
                    })()}

                {isLoggedIn && (
                    <>
                        <NavLink
                            activeClassName="sidebar-item-active"
                            className="sidebar-item"
                            to="/courses"
                        >
                            <BookOpen />
                            <span>Courses</span>
                        </NavLink>
                        <NavLink
                            activeClassName="sidebar-item-active"
                            className="sidebar-item"
                            to="/assessments"
                        >
                            <ClipboardCheck />
                            <span>Assessments</span>
                        </NavLink>
                        {isAdmin && (
                            <NavLink
                                activeClassName="sidebar-item-active"
                                className="sidebar-item"
                                to="/admin-panel"
                            >
                                <Shield />
                                <span>Admin Panel</span>
                            </NavLink>
                        )}
                    </>
                )}
            </nav>

            <div className="sidebar-footer">
                {isLoggedIn ? (
                    <>
                        <button
                            className={`notification-btn ${
                                isNotificationOpen ? 'active' : ''
                            }`}
                            id="bellBtn"
                            onClick={toggleNotificationDrawer}
                            type="button"
                        >
                            <Bell />
                            {unreadCount > 0 && (
                                <div
                                    className="notification-badge"
                                    id="unreadBadge"
                                >
                                    {unreadCount}
                                </div>
                            )}
                        </button>

                        <div
                            className={`avatar-container ${
                                isProfileOpen ? 'active' : ''
                            }`}
                            id="avatarBtn"
                            onClick={toggleProfilePopover}
                        >
                            <div className="sidebar-avatar-initials">
                                {getInitials(name)}
                            </div>
                        </div>
                    </>
                ) : (
                    <NavLink
                        activeClassName="sidebar-item-active"
                        className="sidebar-item"
                        to="/login"
                        style={{ margin: 0 }}
                    >
                        <LogIn />
                        <span>Login</span>
                    </NavLink>
                )}
            </div>
        </aside>
    )
}

export default Sidebar
